import axios from "../axios"
import model from "../../model"

export const readAllWorkRecords = async (userIds, start, end) => {
    let readAllWorkRecordsDTO = model.toAllWorkRecordsDTO({userIds, start, end})
    let res = await axios.post(`/workrecords/all`, readAllWorkRecordsDTO)
    return model.fromWorkRecordsDTO(res.data)
}

export const readWorkRecordsSubmittedStatus = async (userIds, startMonth, endMonth) => {
    let statusDTO = model.toWorkRecordSubmittedStatusDTO({userIds, startMonth, endMonth})
    let res = await axios.post(`/workrecords/submittedStatus`, statusDTO)
    return model.fromWorkRecordSubmittedStatusesDTO(res.data)
}
